export default {
	// 404页面
	//notFound:() => import( /* webpackChunkName: "NotFound" */ '../../views/ymt/notFound.vue'),
	// 工作台
	index:() => import( /* webpackChunkName: "index" */ '../../views/ymt/index.vue'),
	// 登录页
	login:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/login.vue'),
	// 各机构报价详情
	quoteDetail:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/quoteDetail.vue'),
	// 询价详情
	xjDetail:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/xjDetail.vue'),
	// 个人中心
	personalCenter:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/personalCenter.vue'),
	// 富民下载
	downLoad:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/downLoad.vue'),
	//机构推荐人介绍
	referrerInfo:() => import( /* webpackChunkName: "workbench" */ '../../views/ymt/referrerInfo.vue'),
}